<template>
  <b-container fluid class="d-flex pt-3">
    <div class="usermenu">
      <h6 class="ps-3 py-4">Settings</h6>
      <p class="ps-3 py-2 light-txt">Account</p>

      <ul class="menu-txt">
        <li v-for="(menu, index) in menuarray" :key="index" @click="$router.push({ path: menu['FixedHref'] })">
          {{ menu["SubMenuName"] }}
        </li>
        <!-- <li @click="$router.push('/newsEventsList')">News Events</li> -->
      </ul>
      <p class="ps-3 py-2 light-txt">Support</p>
      <!-- <p class="ps-3 py-2 light-txt" @click="$router.push({ path: '/approvalTable' })">
        Approval
      </p> -->
      <ul class="menu-txt">
        <li v-for="(menu, index) in menuarray1" :key="index" @click="$router.push({ path: menu['FixedHref'] })">
          {{ menu["SubMenuName"] }}
        </li>
      </ul>
    </div>
    <div class="main-screen">
      <RouterView />
    </div>
  </b-container>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { RouterView, RouterLink, useRouter } from "vue-router";
import MastersService from "../../../modules/userManagement/Service/MastersService";

export default defineComponent({
  setup() {
    const route = useRouter();

    onMounted(() => {
      route.push({
        path: "/userMaster",
      });

      LoadMenus();
    });

    let menuarray: any = ref([]);
    let menuarray1: any = ref([]);

    async function LoadMenus() {
      debugger;
      let response = await MastersService.GetMenus(2);

      console.log("MenuListStoreTabDetails", response["result"]);

      menuarray.value = response["result"];

      let response1 = await MastersService.GetMenus(3);

      console.log("MenuListStoreTabDetails", response1["result"]);

      menuarray1.value = response1["result"];
    }
    return {
      menuarray,
      menuarray1,
    };
  },
});
</script>

<style lang="scss">
.left-menu {
  // width: 100%;
  // background-color: aliceblue;
  position: sticky !important;
  top: 50;
  left: 0;
}

.menu-txt li {
  width: 100%;
  padding: 3px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  margin-left: 8px;
}

.menu-txt li:hover {
  background-color: white;
}

.menu-txt li:focus {
  background-color: white;
}

.main-screen {
  width: 85%;
}

.usermenu {
  width: 15%;
}

@media only screen and (max-width: 992px) and (min-width: 768px) {
  .main-screen {
    width: 80%;
  }

  .usermenu {
    width: 20%;
  }
}

@media only screen and (max-width: 768px) {
  .main-screen {
    width: 100%;
  }

  .usermenu {
    display: none;
  }
}
</style>
